// extracted by mini-css-extract-plugin
export var aniSpin = "B_d";
export var back = "B_Z";
export var date = "B_0";
export var excerpt = "B_1";
export var head = "B_Y";
export var heading = "B_T";
export var post = "B_2";
export var readmore = "B_3";